export default {
  CIRCULARPROGRESSBAR_CONTAINER: 'CIRCULARPROGRESSBAR_CONTAINER',
  CIRCULARPROGRESSBAR_PROGRESS: 'CIRCULARPROGRESSBAR_PROGRESS',
  
  HISTORYACTORS_CONTAINER: 'HISTORYACTORS_CONTAINER',
  HISTORYACTORS_ACTOR_LIST: 'HISTORYACTORS_ACTOR_LIST',
  
  METRICBAR_CONTAINER: 'METRICBAR_CONTAINER',
  METRICBAR_VALUE_TEXT: 'METRICBAR_VALUE_TEXT',
  METRICBAR_BAR: 'METRICBAR_BAR',
  
  OVERLAY_CONTAINER: 'OVERLAY_CONTAINER',
  
  PENDINGACTORS_CONTAINER: 'PENDINGACTORS_CONTAINER',
  PENDINGACTORS_ACTOR_LIST: 'PENDINGACTORS_ACTOR_LIST',
  
  PRESENTATION_CONTAINER: 'PRESENTATION_CONTAINER',
  PRESENTATION_TITLE_TEXT: 'PRESENTATION_TITLE_TEXT',
  PRESENTATION_CONTENT_TEXT: 'PRESENTATION_CONTENT_TEXT',
  
  REPORTCARD_CONTAINER: 'REPORTCARD_CONTAINER',
  REPORTCARD_TITLE_TEXT: 'REPORTCARD_TITLE_TEXT',
  REPORTCARD_CONTENT_TEXT: 'REPORTCARD_CONTENT_TEXT',
  
  SPEAKERPROFILE_CONTAINER: 'SPEAKERPROFILE_CONTAINER',
  SPEAKERPROFILE_NAME_TEXT: 'SPEAKERPROFILE_NAME_TEXT',
  SPEAKERPROFILE_PROFILE: 'SPEAKERPROFILE_PROFILE',
  
  TYPINGTEXT_CONTAINER: 'TYPINGTEXT_CONTAINER',
  TYPINGTEXT_TEXT: 'TYPINGTEXT_TEXT',
  
  WALKTHROUGHCONTENT_CONTAINER: 'WALKTHROUGHCONTENT_CONTAINER',
  WALKTHROUGHCONTENT_CONTENT_TEXT: 'WALKTHROUGHCONTENT_CONTENT_TEXT',
};



